/**
 * Privacy Policy Page
 *
 * Task: T4.3.4 - Policy pages
 */

import {
  Page,
  Layout,
  Card,
  Text,
  BlockStack,
  Box,
} from '@shopify/polaris';

export function PrivacyPolicyPage() {
  return (
    <Page title="Privacy Policy" narrowWidth>
      <Layout>
        <Layout.Section>
          <Card>
            <Box padding="600">
              <BlockStack gap="600">
                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    1. Introduction
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Welcome to <strong>GiftSangam.com</strong>, a unit of <strong>Novadhara Ventures</strong>.
                    We respect your privacy and are committed to protecting your personal data.
                    This policy outlines how we collect, use, and safeguard your information when
                    you visit our website or place an order.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    2. Information We Collect
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We may collect personal information such as your name, company name, email
                    address, phone number, and shipping address when you:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Request a quote or catalog
                    <br />
                    • Place an order for goods
                    <br />
                    • Subscribe to our newsletter
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    3. How We Use Your Data
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We use your data solely for:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Processing and delivering your orders
                    <br />
                    • Communicating with you regarding inquiries or customization details
                    <br />
                    • Sending invoices and shipment tracking information
                  </Text>
                  <Text as="p" variant="bodyMd">
                    <em>We do not sell, trade, or rent your personal identification information to others.</em>
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    4. Data Security
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We implement appropriate data collection, storage, and processing practices
                    and security measures to protect against unauthorized access or disclosure of
                    your personal information.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    5. Contact Us
                  </Text>
                  <Text as="p" variant="bodyMd">
                    If you have any questions about this Privacy Policy, please contact us at:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Email: <strong>info@giftsangam.com</strong>
                  </Text>
                </BlockStack>
              </BlockStack>
            </Box>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
